exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#login-page {\n  background: black;\n  display: flex;\n  min-height: 100vh;\n  color: #ccc;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column; }\n  #login-page #error {\n    color: #aa3333; }\n  #login-page #login {\n    padding: 3rem;\n    width: 60vw;\n    height: 60vh;\n    border: 2px solid cornflowerblue;\n    border-radius: 0.5rem; }\n    #login-page #login h1 {\n      margin-top: 0;\n      color: white; }\n    #login-page #login label {\n      display: block; }\n    #login-page #login input {\n      display: block;\n      width: 100%;\n      margin-bottom: 1rem; }\n", ""]);

// exports
